import Constants from 'config/Constants';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

export function BlockName({ block }) {
    const { type } = block;

    // Block name
    let name = _.get(block, 'properties.name', '');

    if (type === Constants.blockTypes.linked) {
        name = _.get(block, 'targetProperties.name', '');
    }

    const showName = !_.isEmpty(name);

    // Block prefix
    const blockPrefix = _.get(block, 'properties.blockPrefix', '');
    const blockPrefixSetting = _.get(block, 'properties.blockPrefixSetting', 'manual');

    const showBlockPrefix = blockPrefixSetting === 'auto' || blockPrefix !== '';

    if (!showName && !showBlockPrefix) {
        return null;
    }

    return (
        <div className="block-name flex-center bg-white small p-1">
            {showName && (
                <div className="mr-2" style={{ color: '#00abb4' }}>
                    {name}
                </div>
            )}

            {showBlockPrefix && <BlockPrefix block={block} showName={showName} />}
        </div>
    );
}

function BlockPrefix({ block }) {
    const { t } = useTranslation('documents');

    const blockPrefix = _.get(block, 'properties.blockPrefix', '');
    const blockPrefixSetting = _.get(block, 'properties.blockPrefixSetting', 'manual');
    const blockPrefixType = _.get(block, 'properties.blockPrefixType', 'default');

    return (
        <div className="small text-secondary">
            {t('document.navbar.main.editor.left.blocks.badges.numberingTitle')}:&nbsp;
            {blockPrefixSetting === 'manual' && (
                <>
                    {blockPrefix} {t('document.navbar.main.editor.left.blocks.badges.manual')}
                </>
            )}
            {blockPrefixSetting === 'auto' && (
                <>
                    {blockPrefixType === 'default' && (
                        <>{t('document.navbar.main.editor.left.blocks.badges.123automatic')}</>
                    )}
                    {blockPrefixType === 'numbers_only' && (
                        <>{t('document.navbar.main.editor.left.blocks.badges.123numbersOnly')}</>
                    )}
                    {blockPrefixType === 'small_caps' && (
                        <>{t('document.navbar.main.editor.left.blocks.badges.abcautomatic')}</>
                    )}
                    {blockPrefixType === 'uppercase' && (
                        <>{t('document.navbar.main.editor.left.blocks.badges.ABCautomatic')}</>
                    )}
                </>
            )}
        </div>
    );
}
